const UserAction = {
  CANCEL: 'CANCEL',
};
export const InvoiceAddressForm = {
  showInvoiceAddressForm: (viewModel) => {
    window.InvoiceAddressForm.render(getInvoiceFormDefaultParams(viewModel));
  },
};

const getInvoiceFormDefaultParams = (viewModel) => {
  const { address = {}, unknownCity } = viewModel.sectionsModel.invoice.data;
  let defaultValues = {};
  const isEditAddressMode = viewModel.sectionsModel.invoice.data.isNotEmpty;
  if (isEditAddressMode) {
    defaultValues = { ...address };
  }

  const showCancelButton = !!viewModel.sectionsModel.invoice.hasCancelButton;

  return {
    elementId: 'invoice-address-form-container',
    formAttributes: {
      showCancelButton: showCancelButton,
      consumerName: 'registration',
    },
    defaultValues: defaultValues,
    callback: (data) => {
      handleAddressFormData(data, viewModel);
    },
    error: {
      unknownCityError: unknownCity,
    },
  };
};

const handleAddressFormData = (callbackData, viewModel) => {
  const { action, payload } = callbackData;
  if (action === UserAction.CANCEL) {
    viewModel.setAddressFlow('invoice');
    return;
  }

  storeDataToAngularModel(viewModel, payload);
  viewModel.setAddressFlow('invoice');
};

const storeDataToAngularModel = (viewModel, payload) => {
  viewModel.invoiceAddressForm = {};
  viewModel.invoiceAddressForm.$submitted = true;

  const {
    phoneNumber,
    additionalInformation,
    countryShortName,
    countryCode,
    country,
  } = payload;
  viewModel.invoicePhoneNumber = phoneNumber;
  viewModel.countrySelects.invoice.selectedCountry = {
    name: country,
    iso3166Name: countryCode,
    code: countryShortName,
  };

  payload.company = additionalInformation;
  viewModel.sectionsModel.invoice.data.address = payload;
  viewModel.sectionsModel.invoice.data.isNotEmpty = true;
};
